import { useState } from 'react';
import Zoom from 'react-medium-image-zoom';
import 'react-medium-image-zoom/dist/styles.css';

export const ImageWithZoom = ({ src, alt }) => {
  const [isLoaded, setIsLoaded] = useState(false);
  
  const imageStyle = {
    width: "100%",
    height: "100%",
    objectFit: "contain",
    display: "block",
    opacity: isLoaded ? 1 : 0,
    transition: "opacity 0.3s ease-in-out"
  };

  return (
    <Zoom>
      <img 
        src={src} 
        alt={alt} 
        style={imageStyle}
        onLoad={() => setIsLoaded(true)}
        loading="lazy" // เพิ่ม lazy loading
      />
    </Zoom>
  );
};
